
import classNames from "classnames";

import style from "./account.module.scss";
import AccountProfile from "./AccountProfile";
import {Button} from "../Button/Button";
const UnauthenticatedUser = ({ headername, onBackPress }) => {
    return (
      <div className="userNotLoggedIn">
        <AccountProfile />
        <div className={style.cardRow}>
          <Button bgColor="black">Log in</Button>
          <Button>Access Key</Button>
        </div>
        <div className={style.cardRow}>
          <p>
            <a
              target="_blank"
              className={classNames(style.underline, style.link)}
              rel="noreferrer"
              href="https://app.tg.org.au/"
            >
              app.tg.org.au
            </a>
          </p>
        </div>
      </div>
    );
};

UnauthenticatedUser.propTypes = {

};

export default UnauthenticatedUser;
